import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { FaFileInvoiceDollar } from 'react-icons/fa6';
import MyInvoices from "./index";
import ViewMyInvoice from "./view";
import MyInvoicePreview from "./MyInvoicePreview";
import { MY_INVOICES } from "variables/modules";

const myInvoiceRoutes = [	
	generateCRUDRoutes({
		mainTitle: "My Invoices",
		basePath: "my-invoices",
		mainComponent: <MyInvoices />,
	    layout: "/console",	   
	    icon: <FaFileInvoiceDollar className="icon-item" />,
	    subTitle:"My Invoice",
	    viewComponent: <ViewMyInvoice />,
	    createComponent: <ViewMyInvoice />,
	    editComponent: <ViewMyInvoice />,
		level:4,
		moduleId: MY_INVOICES,
		// submodules: [
			
		// ]
	}),
	{	
		name: "My Invoice Details",
		layout: "/console",
		path: "/my-invoice/:invoiceId",
		component: <MyInvoicePreview />,
		isMainMenu:false,
		level:4,
		moduleId: MY_INVOICES,
	},
	
]

export default myInvoiceRoutes;